// Module
var code = "<canvas ng-show=\"$ctrl.hasOptions\" class=\"pie-chart\" style=\"width:100%;height:100%\"></canvas> <div ng-if=\"!$ctrl.hasOptions\"> Aucun option n'a été définie pour ce widget, mais des options sont requises. Cliquez sur le bouton d'édition des options pour en ajouter. </div> ";
// Exports
export default code;